import * as React from "react";
import { DropDownCell } from "../../../../../Layout/Grid/Cell/Default/DropDownCell";
import { CustomGridCellProps } from "../../../../../Layout/Grid/Cell/CustomGridCellProps";
import { GridRowClickProps } from "../../../../../Layout/Grid/GridRowClickProps";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

export function PUDODropdownCell({
  editable,
  isReadOnly,
  ...props
}: CustomGridCellProps & GridRowClickProps & ReadOnlyProps) {
  const localizedData = [
    { text: "DO-I", value: 1 },
    { text: "PU-I", value: 0 },
    { text: "DO-R", value: 3 },
    { text: "PU-R", value: 2 },
    { text: "-", value: 4 },
  ];
  return (
    <DropDownCell
      {...props}
      localizedData={localizedData}
      editable={editable ?? true}
      isReadOnly={isReadOnly}
    />
  );
}
